<template>
  <div class="agr-list-container">
    <van-nav-bar
      left-arrow
      title="农资管理"
      @click-left="$router.push({name:'Home'})"
      @click-right="$router.push({name:'AgrAdd'})"
    >
      <template #right>
        <van-icon name="plus" size="12" />
        <span>加农资</span>
      </template>
    </van-nav-bar>
    <wh-mobile-list ref="list" :extra-params="extraParams" data-src="/api/getAgriculturalList">
      <template #default="{list}">
        <van-swipe-cell v-for="i in list" :key="i.id" :name="i.id" @click.native="handleItemClick(i)">
          <div class="agr-item">
            <table>
              <tbody>
                <tr>
                  <td class="icon-td" rowspan="2">
                    <svg-icon :icon-class="i.type|getAgrOption|icon" :style="i.type|getAgrOption|color" />
                  </td>
                  <td>
                    <span class="name">{{ i.name }}</span>
                    <span class="type-tag">{{ i.type }}</span>
                    <span class="unit">{{ i | agrUnitFilter }}</span>
                  </td>
                  <td class="count-td" rowspan="2">
                    <span class="count">{{ i | agrCountFilter }}（共{{ i | agrTotalFilter }}）</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="factory">{{ i.factory }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <template #right>
            <van-button
              class="delete-btn"
              color="#FF4444"
              square
              text="删除"
              type="danger"
              @click.stop="handleDelete(i.id)"
            />
          </template>
        </van-swipe-cell>
      </template>
    </wh-mobile-list>
    <agr-record :agr-data="agrData" :visible.sync="popup.record" @success="$refs.list.onRefresh()" />
  </div>
</template>

<script>
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import { agrCountFilter, agrTotalFilter, agrUnitFilter } from '@/filter'
import { agrTypeOptions } from '@/constant/common'
import api from '@/api'
import AgrRecord from '@/views/agrStock/components/AgrRecord'

export default {
  name: 'AgrList',
  components: { AgrRecord, WhMobileList },
  filters: {
    agrUnitFilter, agrCountFilter, agrTotalFilter,
    getAgrOption(type) {
      switch (type) {
        case '种子(苗)':
          return agrTypeOptions['seed']
        case '农药':
          return agrTypeOptions['pesticide']
        case '肥料':
          return agrTypeOptions['fertilizer']
        case '饲料':
          return agrTypeOptions['feed']
        case '兽药':
          return agrTypeOptions['drug']
        default:
          return agrTypeOptions['seed']
      }
    },
    icon(val) {
      return val.icon
    },
    color(val) {
      return `color:${val.color};`
    }
  },
  data() {
    return {
      popup: {
        record: false
      },
      extraParams: {
        type: 'all',
        having: 'all',
        fuzzy: 'true',
        keyword: undefined
      },
      agrData: {}
    }
  },
  methods: {
    handleDelete(id) {
      this.$dialog.confirm({
        message: '确认删除?'
      }).then(() => {
        api.delAgricultural({ id }).then(() => {
          this.$refs.list.onRefresh()
          this.$toast('删除成功')
        })
      }).catch(() => {
      })
    },
    handleItemClick(i) {
      this.agrData = i
      this.popup.record = true
    }
  }
}
</script>

<style lang="less" scoped>
.agr-list-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.van-nav-bar__right {
  span {
    color: @primary-color;
    font-size: 12px;
  }
}
.agr-item {
  padding: 18px;
  background: #fff;
  table {
    width: 100%;
  }
  td {
    vertical-align: middle;
  }
  .icon-td {
    width: 60px;
  }
  .count-td {
    min-width: 90px;
    text-align: right;
  }
  .svg-icon {
    width: 32px;
    height: 32px;
  }
  .name {
    font-size: 14px;
    color: #323332;
    margin-right: 12px;
  }
  .type-tag,
  .unit {
    display: inline-block;
    height: 16px;
    font-size: 12px;
    text-align: center;
    line-height: 16px;
    padding: 0 6px;
    border-radius: 2px;
  }
  .type-tag {
    color: #fff;
    background: @primary-color;
    margin-right: 12px;
  }
  .unit {
    background: #EBFCF8;
    color: @primary-color;
  }
  .count {
    font-size: 14px;
    color: @primary-color;
    white-space: nowrap;
  }
  .factory {
    display: inline-block;
    margin-top: 6px;
    font-size: 12px;
    color: #BBBBBB;
  }
}
.Wh-list {
  padding-top: 8px;
}
.van-swipe-cell {
  margin-bottom: 1px;
  .delete-btn {
    height: 100%;
  }
}
</style>
